module.exports = __webpack_public_path__ + "media/images/redesign-images/shared/best-sellers/best-sellers-06-4938ba351869c63b45b049087fc16c08.jpg";